import CustomFaq from 'components/CustomFaq';

const questionsList = [
  {
    title: 'How do you ensure the accuracy of scientific concepts in your designs?',
    description:
      'Our team includes professionals with a deep understanding of various scientific fields. They work closely with you to ensure that your research and its complex concepts are accurately represented in the designs.',
  },
  {
    title:
      'I have very specific needs for my presentation/infographic. Can you accommodate custom requests?',
    description:
      'Absolutely. We understand that each research project is unique and might require specific science figures, graphical abstracts, diagrams, and graphics. Our team works with you to understand your specific needs and then create custom designs that accurately reflect your research findings and objectives.',
  },
  {
    title:
      'I am concerned about the confidentiality of my unpublished research. How do you handle this?',
    description:
      "We take confidentiality very seriously at Mind the Graph. Any information you provide, especially regarding unpublished research, is treated with the utmost respect and confidentiality. We have stringent policies and procedures in place to ensure your data's security.",
  },
  {
    title:
      'My timelines can be quite tight. Can you deliver high-quality work within strict deadlines?',
    description:
      "Yes, we understand the importance of deadlines in academia and strive to deliver all projects on time without compromising quality. We communicate transparently about timelines and ensure our process is efficient to meet your deadlines. Please note that very strict timelines may impact the project's fee to account for the expedited design process.",
  },
  {
    title:
      'I need a service that saves me time so that I can focus more on my research. Can you help?',
    description:
      "That's exactly what we're here for. Our goal is to take care of the design work, allowing you to focus on your research. Whether it's creating an infographic or designing a presentation, we aim to save you time while delivering high-quality results.",
  },
];

export default function Faq({ alignTitle }) {
  return <CustomFaq questionsList={questionsList} alignTitle={alignTitle} />;
}
